import { Settings2Icon } from 'lucide-react';

export function TiclickTableFilterBtn() {
  return (
    <button className='relative border cursor-pointer h-full flex gap-1 px-3 items-center text-gray-800 border-l-0 rounded-r-lg border-pale-border bg-primary-50 text-sm'>
      <Settings2Icon size={18} />
      Filter
    </button>
  );
}
